module.exports = __webpack_public_path__ + "img/xiaomi-5.970f11f6.png";